import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import app from "../../core/application";
import {sendRequest} from "../../helpers/ajax";
import ILoginToClientRequest from "../../types/ILoginToClientRequest";
import ILoginToClientResponse from "../../types/ILoginToClientResponse";
import IResponse from "../../types/IResponse";
import IUserSession from "../../types/IUserSession";
import LoginToClient from "./LoginToClient";


interface ILoginToClientProps extends RouteComponentProps<any> {
    onLogin: (userSession: IUserSession) => void;
}

interface ILoginToClientState {
    clientHeaderID: number;
}
class LoginToClientContainer extends React.Component<ILoginToClientProps, ILoginToClientState>{

    constructor(props: ILoginToClientProps) {
        super(props);

        this.state = {
            clientHeaderID: 0,
        };
        this.onSubmit = this.onSubmit.bind(this);
    }

    public render() {
        return (
            <LoginToClient 
                onSubmit={this.onSubmit} 
            />
        );
    }

    public async componentDidMount() {
        this.setState({
            clientHeaderID: this.props.match.params.clientHeaderID,
        });        
    }

    private async onSubmit(password: string): Promise<boolean> {
        const appInstance = app();
        if (!appInstance.userSession) {
            return false;
        }

        const data: ILoginToClientRequest = { 
            password,
            clientHeaderID: this.state.clientHeaderID,
         };
        const response = await sendRequest<IResponse<ILoginToClientResponse>>("/api/authentication/LoginToClient", "POST", data);

        if (response) {
            const auth = response.payload;
            if (auth.success) {
                app().logInUser(auth.userSession);
                this.props.onLogin(auth.userSession);

                // Force a full page reload, just to make sure all data is cleared
                window.location.href = "/";
                
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}

export default withRouter(LoginToClientContainer);



// WEBPACK FOOTER //
// ./src/components/LoginToClient/LoginToClientContainer.tsx